module.exports = __webpack_public_path__ + "img/yishi8.ea903cd5.jpg";